export const neighborhoodDetail = {
    chamber2: '二室',
    chamber3: '三室',
    chamber4: '四室',
    chamberThan4: '四室以上',
    title: '楼盘详情',
    sync: '您可以去电脑端构造，也可申请代画',
    refer: '代画户型',
    nodata: '暂无户型',
};
